var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.isLoading)?_c('v-row',[_c('v-col',[_c('loading-spinner')],1)],1):_c('v-row',[_c('v-col',[_c('paginated-table',{attrs:{"data":_vm.news,"columns":_vm.tableColumns,"title":_vm.$t('title.membernews_management')},on:{"updatePagination":_vm.updatePagination}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }